/* eslint-disable no-param-reassign */
import utils from './wallUtils';

const PROMO_SECTION_CLASS = 'promo-section';
const PROMO_IMAGE_CLASS = 'promo-image';

const handlePromoAnalytics = (promoElement) => {
  const type = promoElement.classList.contains(PROMO_SECTION_CLASS) ? 'HTML' : 'Image';
  const isAdvertisment = promoElement.dataset.isAdvertisment === 'true';
  const useFunnelTracking = promoElement.dataset.useFunnelTracking === 'true';
  const { kvatxid } = promoElement.dataset;
  const sectionTitle = promoElement.querySelector('.promo-section__title')?.innerText;

  const promotionBaseData = {
    type,
    isAdvertisment,
    useFunnelTracking,
    kvatxid,
    label: promoElement.dataset.campaignTracking,
  };

  if (sectionTitle) {
    promotionBaseData.title = sectionTitle;
  }

  window.dataLayer?.push({
    event: `promotionView_${kvatxid}`,
    [`promotionView_${kvatxid}`]: {
      ...promotionBaseData,
      action: `${type} ${isAdvertisment ? 'Advertisement' : ''} Promotion Viewed`,
    },
  });

  const clickHandler = (event) => {
    window.dataLayer?.push({
      event: `promotionClick_${kvatxid}`,
      [`promotionClick_${kvatxid}`]: {
        ...promotionBaseData,
        ctaUrl: event.target.href || event.target.parentElement.href,
        ctaText: event.target.innerText || '',
        action: `${type} ${isAdvertisment ? 'Advertisement' : ''} Promotion CTA Clicked`,
      },
    });
  };

  promoElement.querySelectorAll('.js-funnel-tracking-link').forEach((ctaLink) => {
    ['click', 'auxclick'].forEach((event) => {
      ctaLink.addEventListener(event, clickHandler);
    });
  });
};

export const addTrackingSearchParams = (element) => {
  const trackingSearchParams = {
    kvatxid: element.dataset.kvatxid,
    content_url: window.location.href,
  };

  element.querySelectorAll('.js-funnel-tracking-link').forEach((ctaLink) => {
    const updatedUrl = new URL(ctaLink.href);
    Object.entries(trackingSearchParams).forEach(([key, value]) => {
      updatedUrl.searchParams.set(key, value);
    });
    ctaLink.href = updatedUrl.href;
  });
};

const initializeBenefits = () => {
  const benefitsContainerSelector = `.${PROMO_SECTION_CLASS}[data-is-initialized="false"] .promo-section__benefits`;
  utils.addBenefits(benefitsContainerSelector, 'fa-check-circle');

  const customAccentColor = document.querySelector(benefitsContainerSelector).dataset.accentColor;
  if (customAccentColor) {
    document.querySelectorAll(`${benefitsContainerSelector} .paywall__benefits--icon`).forEach((icon) => {
      icon.style.color = customAccentColor;
    });
  }
};

const initializePromoElements = (promoTypeClassName) => {
  document.querySelectorAll(`.${promoTypeClassName}`).forEach((promoElement) => {
    if (promoElement.dataset.isInitialized === 'true') return;

    promoElement.dataset.kvatxid = utils.generateTransactionId();
    if (promoElement.dataset.useFunnelTracking === 'true') {
      addTrackingSearchParams(promoElement);
    }
    handlePromoAnalytics(promoElement);

    if (promoTypeClassName === PROMO_SECTION_CLASS) {
      initializeBenefits();
    }

    promoElement.dataset.isInitialized = true;
  });
};

export const initializePromoSections = () => initializePromoElements(PROMO_SECTION_CLASS);
export const initializeImagePromos = () => initializePromoElements(PROMO_IMAGE_CLASS);
